import { Component, Input, OnInit } from "@angular/core";
import { createOrganisationBillingRecord, getRunIdForDate, Organisation } from "../../common/organisation";
import { INSIGHT_VALUE_TYPE, InsightCard } from "../../ui-components/insight-cards/insight-cards.component";
import { AnalyticsData, AnalyticsService } from "../../model-services/analytics-service";
import { LineData } from "../../charts/line-chart/line-chart.component";
import { CURRENT_STATE_PROJECT_KEY } from "../../common/linqset-model";

@Component({
    selector: 'app-organisation-statistics',
    templateUrl: './organisation-statistics.html',
    styleUrls: ['./organisation-statistics.css'],
    standalone: false
})
export class OrganisationStatisticsComponent implements OnInit {
    @Input() organisation: Organisation
    @Input() projectKey:string

    analyticsData:AnalyticsData
    lineData:LineData
    nodesLineData:LineData
    cards:InsightCard[]

    constructor(private analyticsService:AnalyticsService) {}

    async ngOnInit() {
        await this.createAnalytics()
        this.createStatistics()
    }

    async createAnalytics() {
        this.analyticsData = await this.analyticsService.loadAnalyticsData(this.organisation._key, this.projectKey)
        const data = this.analyticsData && this.analyticsService.loadAnalyticsDataForChart(this.analyticsData.analytics)
        this.lineData = data.changes
        this.nodesLineData = data.nodes
    }

    createStatistics() {
        this.cards = []

        const numModels = this.organisation.models.reduce((t, m) => {
            if (m.projectKey !== CURRENT_STATE_PROJECT_KEY) t.projects++
            else {
                t.projects += m.projects?m.projects.length:0
                t.currentState++
            }
            return t
        }, {currentState: 0, projects:0})

        const latest = this.analyticsData.analytics[this.analyticsData.analytics.length-1]

        const csModelsCard = new InsightCard("Current state models", null, 'Number of current state models', null, numModels.currentState)
        this.cards.push(csModelsCard);

        const projectModelsCard = new InsightCard("Project models", null, 'Number of project models', null, numModels.projects)
        this.cards.push(projectModelsCard);

        const projectsCard = new InsightCard("Projects", null, 'Number of projects', null, this.organisation.projects.length)
        this.cards.push(projectsCard);

        const nodesCard = new InsightCard("Current state nodes", null, 'Number of current state nodes', null, latest.nodes)
        this.cards.push(nodesCard);

        const projectNodesCard = new InsightCard("Project nodes", null, 'Number of project nodes', null, latest.projectNodes)
        this.cards.push(projectNodesCard);

        const backupNodesCard = new InsightCard("backup nodes", null, 'Number of backup nodes', null, latest.backupNodes)
        this.cards.push(backupNodesCard);

        const orphanedNodesCard = new InsightCard("Orphaned nodes", null, 'Number of nodes without a model or project', null, this.analyticsData.orphanedNodes)
        this.cards.push(orphanedNodesCard);

        const orphanedEdgesCard = new InsightCard("Orphaned edges", null, 'Number of edges without a model or project', null, this.analyticsData.orphanedEdges)
        this.cards.push(orphanedEdgesCard);

        const usersCard = new InsightCard("Users", null, 'Number of users', null, this.organisation.numUsers)
        this.cards.push(usersCard);

        const adminsCard = new InsightCard("Admin users", null, 'Number of admin users', null, this.organisation.numAdmins)
        this.cards.push(adminsCard);

        const now = new Date()
        const record = createOrganisationBillingRecord(this.organisation, now, now, getRunIdForDate(now), latest)
        const nodeAmountCard = new InsightCard("Nodes cost", null, 'Currently monthly cost for nodes', null, record.nodes.amount, undefined, INSIGHT_VALUE_TYPE.CURRENCY)
        this.cards.push(nodeAmountCard);
        const projectAmountCard = new InsightCard("Projects cost", null, 'Currently monthly cost for projects', null, record.projects.amount, undefined, INSIGHT_VALUE_TYPE.CURRENCY)
        this.cards.push(projectAmountCard);
        const userAmountCard = new InsightCard("Users cost", null, 'Currently monthly cost for users', null, record.users.amount, undefined, INSIGHT_VALUE_TYPE.CURRENCY)
        this.cards.push(userAmountCard);                
        const amountCard = new InsightCard("Total cost", null, 'Currently total monthly cost', null, record.amount, undefined, INSIGHT_VALUE_TYPE.CURRENCY)
        this.cards.push(amountCard);
    }


}